import React from 'react'
import { useSharkPlugins } from '../../contexts/SharkPluginsProvider'

export default function Copyright() {
    const { sendAction } = useSharkPlugins()

    return (
        <div className="center flex justify-center" style={{ gap: 10 }}>
            <p>Desenvolvido por</p>

            <a href="https://sharkdev.com.br" target="_blank" onClick={() => {
                sendAction({
                    type: "event",
                    action: "clickLogoShark",
                    value: 1
                })
            }}>
                <img src="https://sharkdev.com.br/static/logos/logo_dark.svg" />
            </a>
        </div>
    )
}